<template>
    <div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="params.fab ? params.fab : false"
						:icon="params.fab ? false : true"
						:small="params.small ? true : false"
						:fixed="params.fixed ? true : false"
						:bottom="params.bottom ? true : false"
						:right="params.right ? true : false"
						:dark="params.dark ? true : false"
						:color="params.button_color ? params.button_color : ''"
						@click="toggleDialog">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ button.icon }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ button.tooltip }}</span>
    		</v-tooltip>
		</template>

        <v-list-item v-else-if="buttonComponent == 'v-list-item'"
            dense 
            :disabled="disabled"
            @click.stop="toggleDialog(true)"
            ripple>
            <v-list-item-icon>
                <v-icon style="font-size: 18px">{{ button.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ button.tooltip }}</v-list-item-title>
            </v-list-item-content>    
        </v-list-item>    

        <v-dialog
            v-model="dialogOpen"
            width="600"
            persistent
            @input="$emit('update:open', $event)">
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Numeri di telefono</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container>
                        <v-row class="pb-3 px-2 pt-4">
                            <v-col class="px-4 py-0" cols="12">
                                <v-progress-circular 
                                    v-if="loading && !phoneNumbersData.length"
                                    indeterminate 
                                    color="primary"
                                    class="mx-auto d-block my-5"
                                ></v-progress-circular>
                                <v-list v-else>
                                    <v-list-item
                                        v-for="(phone, index) in phoneNumbersData"
                                        :key="index"
                                        @click="callNumber(phone)">
                                        <v-list-item-icon>
                                            <v-icon color="primary">mdi-phone</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="ml-4">
                                            <v-list-item-title>{{ phone.label }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ phone.value }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn
                                                outlined
                                                color="primary"
                                                @click.stop="callNumber(phone)">Chiama
                                                <v-icon>mdi-phone-outgoing</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item v-if="phoneNumbersData.length === 0 && !loading">
                                        <v-list-item-content>
                                            <v-list-item-title class="text-center">Nessun numero di telefono disponibile</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="red" @click="closeDialog">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: 'start-call-button',
        props: {
            open: Boolean,
            id: Number,
            button: Object,
            buttonComponent: {type: String, default : 'v-btn'},
            model: Object,
            info: Object,
            params: Object,
            modelDef: String,
            disabled: Boolean
        },

        data() {
            return {
                loading: false,
                dialogOpen: false,
                phoneNumbersData: [],
                popupText: '',
                callSubject: ''
            }
        },

        methods: {
            toggleDialog() {
                this.dialogOpen = !this.dialogOpen
                if (this.dialogOpen && this.model && this.model.id) {
                    this.loadPhoneNumbers()
                }
                this.$emit('update:open', this.dialogOpen)
            },
            
            loadPhoneNumbers() {
                this.loading = true
                this.axios.get(`/companies-phone-numbers/${this.model.id}`)
                    .then(response => {
                        this.phoneNumbersData = response.data.phone_numbers
                        // Store popup_text and subject from backend response
                        this.popupText = response.data.popup_text || ''
                        this.callSubject = response.data.subject || ''
                        this.loading = false
                    })
                    .catch(error => {
                        console.error('Error loading phone numbers:', error)
                        this.loading = false
                        this.showSnackbar(this.errorMessage(error, 'Errore nel caricamento dei numeri telefonici'), 'error')
                    })
            },
            
            closeDialog() {
                this.dialogOpen = false
                this.$emit('update:open', false)
                this.$emit('close')
            },
            
            callNumber(phone) {
                if (phone && phone.key) {
                    this.loading = true
                    
                    let postData = {
                        phone_key: phone.key,
                        model_id: this.model.id,
                        popup_text: this.popupText,
                        subject: this.callSubject
                    }
                    if(phone.custom_field_id) {
                        postData.custom_field_id = phone.custom_field_id
                    }
                    // Use phone key instead of phone number
                    this.axios.post('/make-call', postData).then(response => {
                        this.loading = false

                        if (response.data.success) {
                            this.showSnackbar('Chiamata in corso...', 'success')
                        } else {
                            this.showSnackbar(response.data.message || 'Errore nell\'avvio della chiamata', 'error')
                        }

                        // Emit event for parent components
                        this.$emit('call-initiated', phone.key)

                        // Close the dialog
                        this.closeDialog()
                    }).catch(error => {
                        this.loading = false
                        console.error('Call error:', error)

                        this.showSnackbar(this.errorMessage(error, 'Errore nel sistema di chiamata'), 'error')
                    })
                }
            },

            showSnackbar(text, color) {
                this.$store.commit('setSnackbar', {
                    timeout: 6000,
                    text: text,
                    value: true,
                    color: color
                })
            },

            errorMessage(error, fallback) {
                return error.response?.data?.message || fallback
            }
        },
        
        watch: {
            open(newVal) {
                this.dialogOpen = newVal
                if (newVal && this.model && this.model.id) {
                    this.loadPhoneNumbers()
                }
            }
        },
        
        created() {
            this.dialogOpen = this.open
            if (this.open && this.model && this.model.id) {
                this.loadPhoneNumbers()
            }
        }
    }
</script>